// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmDialog_confirm_wrap__KZOz4 {
  position: absolute;
  z-index: 101;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_confirm_dialog__ox3l7 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 25%;
  background-color: white;
  padding: 25px;
  border-radius: 16px;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_confirm_dialog__ox3l7 .confirmDialog_loader__x08qJ {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 16px;
}
.confirmDialog_confirm_wrap__KZOz4 h2 {
  margin-bottom: 5px;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_confirm_button__BL328,
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_cancel_button__s\\+yFn {
  padding: 8px 12px;
  border-radius: 12px;
  background-color: transparent;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_confirm_button__BL328 {
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
  transition: all 0.3s ease-in-out;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_confirm_button__BL328:hover {
  background-color: var(--primary-color);
  color: white;
  transition: all 0.3s ease-in-out;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_cancel_button__s\\+yFn {
  border: 2px solid #e74c3c;
  color: #e74c3c;
  transition: all 0.3s ease-in-out;
}
.confirmDialog_confirm_wrap__KZOz4 .confirmDialog_button_wrap__YDP8b .confirmDialog_cancel_button__s\\+yFn:hover {
  background-color: #e74c3c;
  color: white;
  transition: all 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Dialogs/ConfirmDialog/confirmDialog.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,QAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oCAAA;EACA,mBAAA;AACN;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AAFJ;AAII;;EAEE,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAFN;AAKI;EACE,sCAAA;EACA,2BAAA;EACA,gCAAA;AAHN;AAKM;EACE,sCAAA;EACA,YAAA;EACA,gCAAA;AAHR;AAOI;EACE,yBAAA;EACA,cAAA;EACA,gCAAA;AALN;AAOM;EACE,yBAAA;EACA,YAAA;EACA,gCAAA;AALR","sourcesContent":[".confirm_wrap {\n  position: absolute;\n  z-index: 101;\n  width: 100%;\n  height: 100vh;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n\n  .confirm_dialog {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: 25%;\n    background-color: white;\n    padding: 25px;\n    border-radius: 16px;\n\n    .loader {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      background-color: rgba(0, 0, 0, 0.3);\n      border-radius: 16px;\n    }\n  }\n\n  h2 {\n    margin-bottom: 5px;\n  }\n\n  .button_wrap {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n\n    .confirm_button,\n    .cancel_button {\n      padding: 8px 12px;\n      border-radius: 12px;\n      background-color: transparent;\n      font-size: 12px;\n      font-weight: 600;\n      text-transform: uppercase;\n      cursor: pointer;\n    }\n\n    .confirm_button {\n      border: 2px solid var(--primary-color);\n      color: var(--primary-color);\n      transition: all 0.3s ease-in-out;\n\n      &:hover {\n        background-color: var(--primary-color);\n        color: white;\n        transition: all 0.3s ease-in-out;\n      }\n    }\n\n    .cancel_button {\n      border: 2px solid #e74c3c;\n      color: #e74c3c;\n      transition: all 0.3s ease-in-out;\n\n      &:hover {\n        background-color: #e74c3c;\n        color: white;\n        transition: all 0.3s ease-in-out;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirm_wrap": `confirmDialog_confirm_wrap__KZOz4`,
	"confirm_dialog": `confirmDialog_confirm_dialog__ox3l7`,
	"loader": `confirmDialog_loader__x08qJ`,
	"button_wrap": `confirmDialog_button_wrap__YDP8b`,
	"confirm_button": `confirmDialog_confirm_button__BL328`,
	"cancel_button": `confirmDialog_cancel_button__s+yFn`
};
export default ___CSS_LOADER_EXPORT___;
